import React, { Component } from 'react'
import { infoScreenAriaLabel } from '../Constants/AriaLabelText'
import { injectIntl, FormattedMessage } from 'react-intl'


class InfoProfileVisibility extends Component {
  render() {
    const { intl } = this.props
    return (
      <div>
        <div className="as-info-modal-wrapper">
          <div className="as-info-modal-close">
            <a
              href="javascript:void(0);"
              aria-label={infoScreenAriaLabel(intl)['close']}
              onClick={() => this.props.hideModal()}
              className="icon-cross as-profile-edit-close-btn modal-close-button"
            />
          </div>
          <div className="as-info-modal-heading">
            <FormattedMessage
              id="infoProfileVisibility.heading"
              defaultMessage="Profile visibility?"
            />
          </div>
          <div className="as-info-modal-subheading">
            <FormattedMessage
              id="infoProfileVisibility.subheading"
              defaultMessage="What is profile visibility?"
            />
          </div>
          <div className="as-info-modal-desc">
            <FormattedMessage
              id="infoProfileVisibility.description"
              defaultMessage="Profile visibility refers to how early your profile features in a list of profiles when recruiters search by some keywords. Including keywords relevant to your target job function(s) in your profile helps improve your SEO ranking and increases the chances of recruiters finding your profile earlier."
            />
            {' '}
          </div>
          <div className="row as-info-modal-content as-info-modal-content-profile">
            <div className="col-sm-6">
              <div className="smp-img">
                {' '}
                <img
                  src={`${process.env.APP_BASE_URL}dist/images/info_ProfileVisibility.svg`}
                  width="100%"
                  alt=""
                />{' '}
              </div>
            </div>
            <div className="col-sm-6">
              <div className="smp-bullets">
                <h4
                  tabIndex={0}
                  aria-label={
                    infoScreenAriaLabel(intl)['visibility']['sample']['text']
                  }>
                  {' '}
                  <FormattedMessage
                    id="infoProfileVisibility.elementsHeading"
                    defaultMessage="Elements that help make a LinkedIn profile more visible:"
                  />
                </h4>
                <div className="smp-bullets-content ">
                  <div className="smp-icon visibility-icons">
                    {' '}
                    <img
                      alt=""
                      src={`${process.env.APP_BASE_URL}dist/images/ic_seo.svg`}
                      width="18px"
                      height="18px"
                    />
                  </div>
                  <div className="smp-data">
                    <h5
                      tabIndex={0}
                      aria-label={
                        infoScreenAriaLabel(intl)['visibility']['sample'][
                          'keyword'
                        ]
                      }>
                      <FormattedMessage
                        id="infoProfileVisibility.useStandardKeywords"
                        defaultMessage="Use standard keywords"
                      />
                    </h5>
                    <p>
                      {' '}
                      <FormattedMessage
                        id="infoProfileVisibility.useStandardKeywordsDesc"
                        defaultMessage="Using standard terminologies for job roles, competencies, skills, and any other jargon helps your profile match search queries that recruiters use."
                      />
                      {' '}
                    </p>
                  </div>
                  <br />
                  <br />
                  <div className="smp-icon visibility-icons">
                    {' '}
                    <img
                      alt=""
                      src={`${process.env.APP_BASE_URL}dist/images/ic_more_skills.svg`}
                      width="18px"
                      height="18px"
                    />{' '}
                  </div>
                  <div className="smp-data">
                    <h5
                      tabIndex={0}
                      aria-label={
                        infoScreenAriaLabel(intl)['visibility']['sample'][
                          'skill'
                        ]
                      }>
                      <FormattedMessage
                        id="infoProfileVisibility.stateMoreSkills"
                        defaultMessage="State more skills"
                      />
                    </h5>
                    <p>
                      {' '}
                      <FormattedMessage
                        id="infoProfileVisibility.stateMoreSkillsDesc"
                        defaultMessage="Include as many skills relevant to target function(s) as possible in your profile so that when the recruiter searches with any skill relevant to your target function(s), your profile prominently features at the top of the list."
                      />
                      {' '}
                    </p>
                  </div>
                  <br />
                  <br />
                  <div className="smp-icon visibility-icons">
                    {' '}
                    <img
                      alt=""
                      src={`${process.env.APP_BASE_URL}dist/images/ic_information_category.svg`}
                      width="18px"
                      height="18px"
                    />{' '}
                  </div>
                  <div className="smp-data">
                    <h5
                      tabIndex={0}
                      aria-label={
                        infoScreenAriaLabel(intl)['visibility']['sample'][
                          'category'
                        ]
                      }>
                      <FormattedMessage
                        id="infoProfileVisibility.specifyInfoCategories"
                        defaultMessage="Specify Information Categories"
                      />
                    </h5>
                    <p>
                      {' '}
                      <FormattedMessage
                        id="infoProfileVisibility.specifyInfoCategoriesDesc"
                        defaultMessage="Mentioning job roles, job functions, schools, companies, all help in directing your profile towards searches that recruiters would be doing."
                      />
                      {' '}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(InfoProfileVisibility)
